export const connect = {
  subtitle: "Create an account to request an appointment with {{pracName}}",
  pracAvatarAlt: "Avatar for {{pracName}}",
} as const;
